<template>
<mdb-modal :show="modalCart" title="Cart" size="lg" @close="modalCart = false" >
            <mdb-modal-header>
                <mdb-modal-title class="font-weight-bold">SELECTED ITEMS</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>
             <mdb-row>
                        <mdb-col lg="12" md="12" sm="12" >
                            <template v-if="cart!== null && cart.length > 0">
                                <mdb-row v-for="(item,index) in cart" :key="index" class="item-crt">
                                    <mdb-col md="4" lg="3" sm="12" class="cart-item-image">
                                        <div class="item-img-crt">
                                        <img :src="item.U_imgURL" alt=""/>
                                        </div>
                                    </mdb-col>
                                    
                                    <mdb-col md="8" class=" pt-3 cart-item-details"  lg="9" sm="12">
                                        <div class="item-info-crt pl-3 pr-1 align-self-start">
                                            {{item.ItemDescription }} <br />
                                            <span class="text-muted text-small">
                                            {{item.ItemCode}}
                                            </span>
                                        </div>
                                        
                                        <div class="item-info-crt-right pl-3 pr-1">
                                            {{$utils.formatMoney(item.UnitPrice)}}
                                        </div>
                                        
                                        <template v-if="user">
                                            <div class="def-number-input number-input safari_only mt-2 mb-2">
                                            <button type="button" @click="decrementItem(index,item)" class="minus"></button>
                                            <input class="quantity" min="1" name="quantity" v-model="item.Quantity" readonly type="number">
                                            <button type="button" class="plus" @click="incrementItem(item)"></button>
                                            </div>
                                            <div class="item-info-crt pl-3 pr-1">
                                                <p class="text-right"><strong>{{$utils.formatMoney(item.LineTotal)}}</strong></p>
                                            </div>
                                        </template>
                                        
                                        <a href="javascript:void(0)" class="text-decoration-none text-uppercase remove-item-crt mt-1" @click="fnRemoveItem(index,item)"><close-icon></close-icon> Remove</a>

                                    </mdb-col>

                                <div class="w-100"><hr class="hr-dark"></div>
                            </mdb-row>

                    
                            </template>
                            <template v-else>
                                <div class="empty-cart-note">
                                    <p>No Item Selected</p>
                                </div>
                            </template>
                        </mdb-col>
                        <mdb-col lg="12" md="12" sm="12">
                            <mdb-card class="cart-item-card cart-item-summary z-depth-0">
                                <mdb-card-body>
                                    <div class="item-detail-crt w-100">
                                        <dl class="row mx-0 mb-0">
                                            <dt class="col-sm-6 text-left item-total">Total</dt>
                                            <dd class="col-sm-6 text-right item-total-equal">{{cartTotal}}</dd>
                                        </dl>
                                    </div>
                                </mdb-card-body>
                                </mdb-card>
                        </mdb-col>
                   </mdb-row>
                
          </mdb-modal-body>
          <mdb-modal-footer>
            <div class="item-detail-crt w-100">
                                    <dl class="row">
                                      

                                        <dd class="col-sm-12 col-md-6 col-lg-6 text-left">
                                        <mdb-btn size="sm" color="elegant" class="z-depth-0" @click="modalCart = false">CLOSE</mdb-btn>
                                        <mdb-btn size="sm" color="elegant" class="z-depth-0" @click="clearCart">CLEAR SELECTION</mdb-btn>
                                        <mdb-btn size="sm" color="elegant" class="z-depth-0" @click="exportPDF">EXPORT PDF</mdb-btn>
                                        <mdb-btn size="sm" color="elegant" class="z-depth-0" @click="sendToEmail">SEND TO EMAIL</mdb-btn>
                                        </dd>

                                        <template v-if="cart.length > 0 && user">
                                        <dd class="col-sm-6 col-md-6 col-lg-6 text-right"><mdb-btn size="sm" color="elegant" class="z-depth-0" @click="checkoutCart">CHECKOUT</mdb-btn></dd>
                                        </template>

                                    </dl>

                                    </div>
          </mdb-modal-footer>
  
      </mdb-modal>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {mdbRow, mdbCol, mdbCard, mdbCardBody,  mdbBtn, mdbModal, mdbModalBody, mdbModalHeader, mdbModalTitle, mdbModalFooter} from 'mdbvue'
export default {
    name : "CartModal",
    components : {
        mdbRow, mdbCol, mdbCard, mdbCardBody, mdbBtn, mdbModal, mdbModalBody, mdbModalHeader, mdbModalTitle, mdbModalFooter
    },
    data : () => ({
        modalCart : false,
    }),
    
    methods : {
        ...mapActions('CartModule',[
            'addToCart','getCart','updateCart','deleteItem','placeOrder','createCart'
        ]),
        incrementItem(v){
            const Quantity = v.Quantity + 1;
            v.Quantity = Quantity;
            var UnitPrice = this.$utils.unformat(v.UnitPrice);
            v.LineTotal = parseFloat(UnitPrice) * parseInt(Quantity);
            this.updateCart(v)
        },
        decrementItem(index,v){

            
            if(v.Quantity >= 2){

                const Quantity = v.Quantity - 1;
                v.Quantity = Quantity;

                var UnitPrice = this.$utils.unformat(v.UnitPrice);
                v.LineTotal = parseFloat(UnitPrice) * parseInt(Quantity);
                console.log("decrementItem",v)
                this.updateCart(v)
            }
        },

        fnRemoveItem(index,item){

                const self = this

                const swalWithBootstrapButtons = this.$swal.mixin({
                    customClass: {
                        confirmButton: 'btn btn-success z-depth-0',
                        cancelButton: 'btn btn-danger z-depth-0'
                    },
                    buttonsStyling: false
                    })

                    swalWithBootstrapButtons.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, remove it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                    }).then((result) => {
                    if (result.isConfirmed) {
                        console.log("deleteItem",item)
                        self.deleteItem(item).then((res) => {

                            console.log("delete response",res)
                            swalWithBootstrapButtons.fire(
                                'Removed!',
                                'Item has been removed.',
                                'success'
                                )
                                self.cart.splice(index,1)
                        }).catch(() => {
                            swalWithBootstrapButtons.fire(
                            'Cancelled',
                            'Something went wrong',
                            'error'
                            )
                        })  
                        
                    } else{
                        swalWithBootstrapButtons.fire(
                        'Cancelled',
                        'Action cancelled',
                        'error'
                        )
                    }
                    })

        },

        

        clearCart(){

            const self = this

            const swalClearCart = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success z-depth-0',
                    cancelButton: 'btn btn-danger z-depth-0'
                },
                buttonsStyling: false
                });

                swalClearCart.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, clear it!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
                }).then((result) => {
                if (result.isConfirmed) {
                    
                    self.createCart().then((res) => {

                        console.log("create response",res)
                        swalClearCart.fire(
                            'Created!',
                            'Cart has been created.',
                            'success'
                            )
                    }).catch(() => {
                        swalClearCart.fire(
                        'Cancelled',
                        'Something went wrong',
                        'error'
                        )
                    })  
                    
                } else{
                    swalClearCart.fire(
                    'Cancelled',
                    'Action cancelled.',
                    'error'
                    )
                }
                })
        },

        checkoutCart(){
            if(this.cart.length > 0){
                this.$router.push({ name: 'checkout-customer-details' });
                this.closeModal();
            }
        },

        openModal(){
            this.modalCart = true
        },

        closeModal(){
            this.modalCart = false
        },
        exportPDF(){
            window.open(`/catalog/${this.cartData.cartKey}`, '_blank');
            
        },
        sendToEmail(){
            this.$eventBus.$emit('send-to-email');
            this.closeModal();
        }

    },

    computed : {
        ...mapGetters('CartModule',['cart','cartData']),
        ...mapGetters('AuthModule',['user']),
        cartTotal : function(){
            const total = this.cart.map((item) => {
                    return this.$utils.unformat(item.LineTotal)
                }).reduce((a, b) => a + b, 0);
            return this.$utils.formatMoney(total);
        }
    },

}
</script>